var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"warpper_con"},[_c('a-form-model',{ref:"dataInfo",attrs:{"model":_vm.dataInfo,"rules":_vm.rules}}),_c('div',{staticClass:"btn_center"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.submitForm}},[_vm._v(" 保存 ")])],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warpper_top"},[_c('h1',{staticClass:"warpper_top_title"},[_vm._v("系统设置")])])
}]

export { render, staticRenderFns }